// extracted by mini-css-extract-plugin
export default {"input":"DateInput_input__8qbj1","grey":"DateInput_grey__cyl+5"};